export default __webpack_public_path__ + "static/media/send-mail.b16e5439.svg";